export default __webpack_public_path__ + "static/media/bacon.1d7d8f02.mp4";